import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from "react-router-dom";
import { removeFromCart } from './actions/';

class CartTable extends React.Component{

	handleClick = (id) => {
		this.props.removeFromCart(id)
	}

	render(){

		console.log(this.props.state === undefined)

		if(this.props.state === undefined){
			return(

				<div className="alert alert-warning" role="alert">
					Cart is empty, please add some products!
				</div>
				)
		}

		else{

			const renderedProducts = this.props.state.addedItems.map((product) => {
				return(
					<tr key = {product.id}>
						<td>{product.name}</td>
						<td>{product.quantity}</td>
						<td>{product.price}</td>
						<td>{product.price * product.quantity}</td>
						<td>
							<button onClick = {() => {this.handleClick(product.id)}}>
								<i className ="close icon"></i>
							</button>
						</td>
					</tr>
				)
			})

			return (
				<div>
					<table className = "table">
						<thead className = "thead-dark">
							<tr>
								<td>Name</td>
								<td>Quantity</td>
								<td>Price</td>
								<td>Subtotal</td>
							</tr>
						</thead>
						<tbody>
						{renderedProducts}
						</tbody>
					</table>
					<div className = "tableTotal" style = {{textAlign: 'right'}}>

						<p>Total: {this.props.state.total}</p>
						<NavLink to = "/Checkout">
							<button type="button" className="btn btn-primary">Proceed To Checkout</button>
						</NavLink>
					</div>
				</div>
				)
		}
	}
}

const mapStateToProps= (state)=>{
    return{
        state: state
    }
}

const mapDispatchToProps= (dispatch)=>{
    return{
        removeFromCart: (id)=>{dispatch(removeFromCart(id))}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CartTable);